// fcmConfig.js

import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// FCM Project Config
const fcmConfig = {
  apiKey: "AIzaSyAmkHGAljtJNpfh1rcJMtdabYimw_9049Q",
  authDomain: "posible-notification.firebaseapp.com",
  projectId: "posible-notification",
  storageBucket: "posible-notification.firebasestorage.app",
  messagingSenderId: "142946129749",
  appId: "1:142946129749:web:a9542c168df6c8a07e81dc"
};


// Named app (important)
const fcmApp = initializeApp(fcmConfig, "posible-web");

export const messaging = getMessaging(fcmApp);